import PlatformSubscriptionPlans from './PlatformSubscriptionPlans';

export default PlatformSubscriptionPlans;
